(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/behaviors/team-selector-and-subscription-info.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/behaviors/team-selector-and-subscription-info.js');

'use strict';

svs.numbergames.game.behaviors.teamSelectorAndSubscriptionInfo = Marionette.Behavior.extend({
  modelEvents: {
    'change:isSubscription': 'updateChildViews'
  },
  onInitialize() {
    this.mergeOptions(this.options, ['subscriptionInfoRegionSelector', 'accountSelectorRegionSelector']);
  },
  onRender() {
    if (!svs.numbergames.game.utils.isSelfService()) {
      this.updateChildViews();
    }
  },
  showAccountSelector() {
    if (this.view.showAccountSelector && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      this.view.showChildView(this.accountSelectorRegionSelector, new svs.numbergames.game.views.PlayTogetherSelector({
        model: this.view.model
      }));
    }
  },
  showSubscriptionInfo() {
    if (this.view.showSubscriptionInfo) {
      this.view.showChildView(this.subscriptionInfoRegionSelector, new svs.numbergames.game.views.SubscriptionInfo({
        model: this.view.model
      }));
    }
  },
  updateChildViews() {
    if (this.view.model.get('isSubscription')) {
      if (this.accountSelectorRegionSelector) {
        var _this$view$getChildVi, _this$view$getChildVi2;
        (_this$view$getChildVi = this.view.getChildView(this.accountSelectorRegionSelector)) === null || _this$view$getChildVi === void 0 || (_this$view$getChildVi2 = _this$view$getChildVi.destroy) === null || _this$view$getChildVi2 === void 0 || _this$view$getChildVi2.call(_this$view$getChildVi);
      }
      this.showSubscriptionInfo();
    } else {
      if (this.subscriptionInfoRegionSelector) {
        var _this$view$getChildVi3, _this$view$getChildVi4;
        (_this$view$getChildVi3 = this.view.getChildView(this.subscriptionInfoRegionSelector)) === null || _this$view$getChildVi3 === void 0 || (_this$view$getChildVi4 = _this$view$getChildVi3.destroy) === null || _this$view$getChildVi4 === void 0 || _this$view$getChildVi4.call(_this$view$getChildVi3);
      }
      this.showAccountSelector();
    }
  }
});

 })(window);